
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6mvtm", function(module, exports) {
$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $e62c9da570d0cc47$export$7b31a9938ec3ba75; });
const $e62c9da570d0cc47$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("3t7DW", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $be9c067c7be4fda0$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $f3gS9 = parcelRequire("f3gS9");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $6mvtm = parcelRequire("6mvtm");

var $eRzlV = parcelRequire("eRzlV");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $i2Oi2 = parcelRequire("i2Oi2");

var $hp3ar = parcelRequire("hp3ar");

var $gLm0b = parcelRequire("gLm0b");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-40dbdbe3b4";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $be9c067c7be4fda0$var$BASE_URL = "https://www.atlassian.com";
const $be9c067c7be4fda0$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $be9c067c7be4fda0$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $6mvtm.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $i2Oi2.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $f3gS9.loadQuery)(relayEnvironment, query, queryVars);
        const page = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $f3gS9.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: [
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "canonical",
                        href: `${$be9c067c7be4fda0$var$BASE_URL}${route}`
                    }),
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${$be9c067c7be4fda0$var$BASE_URL}${route}`,
                        hrefLang: "x-default"
                    }),
                    isStatic && $be9c067c7be4fda0$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                            rel: "alternate",
                            href: `${$be9c067c7be4fda0$var$BASE_URL}/${langRoute}${route}`,
                            hrefLang: hrefLang
                        }, hrefLang)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        loggedInContext: window.loggedInContext,
                        loggedInContextStatus: window.loggedInContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        anchor: window.anchor,
                        subAnchor: window.subAnchor,
                        queryRef: queryRef,
                        PageComponent: Component,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent
                    })
                ]
            })
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("i2Oi2", function(module, exports) {
$parcel$export(module.exports, "initRelayEnvironment", function () { return $36b5b9e576032b2f$export$1456be3de97c862f; });

var $gRpMo = parcelRequire("gRpMo");
(0, $gRpMo.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $36b5b9e576032b2f$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : $36b5b9e576032b2f$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $gRpMo.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $gRpMo.Network).create(fetchResponse);
    const store = new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)(initialRecords));
    return new (0, $gRpMo.Environment)({
        network: network,
        store: store
    });
}
let $36b5b9e576032b2f$var$clientSideRelayEnvironment;
function $36b5b9e576032b2f$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $36b5b9e576032b2f$var$clientSideRelayEnvironment !== null && $36b5b9e576032b2f$var$clientSideRelayEnvironment !== void 0 ? $36b5b9e576032b2f$var$clientSideRelayEnvironment : $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$36b5b9e576032b2f$var$clientSideRelayEnvironment) $36b5b9e576032b2f$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $gRpMo.RecordSource)(initialRecords));
    return $36b5b9e576032b2f$var$clientSideRelayEnvironment;
}

});


parcelRegister("koI83", function(module, exports) {
$parcel$export(module.exports, "getPricingTitleInternal", function () { return $31a5684656309797$export$933c1404a4ee79b; });
const $31a5684656309797$export$933c1404a4ee79b = ()=>{
    return "Jira Pricing Page";
};

});

parcelRegister("Q2S5p", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPage", function () { return $3f3699cf5f70cbd9$export$743fd6231b24dcf9; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $3L8ZR = parcelRequire("3L8ZR");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("l8kCZ");
var $bTseT = parcelRequire("bTseT");
parcelRequire("f0U7g");
var $5yFib = parcelRequire("5yFib");

var $ea4mV = parcelRequire("ea4mV");
const $3f3699cf5f70cbd9$export$743fd6231b24dcf9 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $3L8ZR.default).checkGate("gwp-737-enable-intercom-chat-jsw");
    const [hasFired, fireExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).jiraPricingWaeMigrationExperimentRerunExp);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: "p0ww63i2",
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProvider), {
            productId: "jira-software",
            pricingContent: pricingContent,
            queryRef: queryRef,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5yFib.JiraSoftwarePricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
};

});
parcelRegister("l8kCZ", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("bTseT")).IntercomProvider; });
parcelRequire("bTseT");
parcelRequire("25OgP");

});
parcelRegister("bTseT", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return $d787a990cb9c57de$export$5091c5023e5c7eba; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $PE2DD = parcelRequire("PE2DD");

var $cIXzQ = parcelRequire("cIXzQ");
const $d787a990cb9c57de$var$isWindowExist = typeof window !== "undefined";
const $d787a990cb9c57de$export$e578ca56db818a8e = /*#__PURE__*/ $1oC0p.createContext(undefined);
const $d787a990cb9c57de$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $1oC0p.useRef(false);
    const isInit = $1oC0p.useRef(false);
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const initIntercomInstance = $1oC0p.useCallback(()=>{
        if (!isInit.current) {
            (0, $cIXzQ.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $1oC0p.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $1oC0p.useCallback(async ()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isInit.current && !isBooted.current) {
            var _window_intercomSettings;
            const intercomSettings = (_window_intercomSettings = window.intercomSettings) !== null && _window_intercomSettings !== void 0 ? _window_intercomSettings : {
                app_id: appId
            };
            try {
                var _window_Intercom, _window, _window_Intercom1, _window1;
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "boot", (0, $6ogO3._)({
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher"
                }, intercomSettings));
                (_window_Intercom1 = (_window1 = window).Intercom) === null || _window_Intercom1 === void 0 ? void 0 : _window_Intercom1.call(_window1, "trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $1oC0p.useCallback(()=>{
        if (!isBooted.current) return;
        if ($d787a990cb9c57de$var$isWindowExist) {
            var _window_Intercom, _window;
            (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $1oC0p.useCallback(()=>{
        var _window_Intercom, _window;
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "show");
    }, []);
    const hide = $1oC0p.useCallback(()=>{
        var _window_Intercom, _window;
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "hide");
    }, []);
    $1oC0p.useEffect(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $6GqRO.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($d787a990cb9c57de$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $1oC0p.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d787a990cb9c57de$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $d787a990cb9c57de$export$28418e623d2470bc = ()=>{
    const context = $1oC0p.useContext($d787a990cb9c57de$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("cIXzQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578d2b441e63143c$export$2e2bcd8739ae039; });
function $578d2b441e63143c$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $578d2b441e63143c$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            var _x_parentNode;
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x === null || x === void 0 ? void 0 : (_x_parentNode = x.parentNode) === null || _x_parentNode === void 0 ? void 0 : _x_parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($578d2b441e63143c$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $578d2b441e63143c$export$2e2bcd8739ae039 = $578d2b441e63143c$var$initializeIntercomInstance;

});


parcelRegister("25OgP", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("f0U7g", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPageV2Template", function () { return (parcelRequire("5yFib")).JiraSoftwarePricingPageV2Template; });
parcelRequire("5yFib");

});
parcelRegister("5yFib", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPageV2Template", function () { return $cdf4d25a3c43b2b5$export$413c805c73a21678; });

var $7VQPk = parcelRequire("7VQPk");

var $in5fb = parcelRequire("in5fb");

var $kIC93 = parcelRequire("kIC93");

var $h9b6O = parcelRequire("h9b6O");

var $g1ccm = parcelRequire("g1ccm");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $2zOxm = parcelRequire("2zOxm");

var $bE8d4 = parcelRequire("bE8d4");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");

var $5S2vX = parcelRequire("5S2vX");

var $8IN8s = parcelRequire("8IN8s");

var $b7CnU = parcelRequire("b7CnU");
const $cdf4d25a3c43b2b5$export$413c805c73a21678 = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const dataCenterContent = (0, $dl2JF.useDatacenterPlans)("Contact Us", "Learn more");
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[1];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "jira-software-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CnU.JiraPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h9b6O.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "jiraSoftware",
                    stickyCtasEnabled: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $in5fb.DataCenterPromoCard), {
                    dataCenterContent: dataCenterContent
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kIC93.TwcPromo), {
                    product: "jira"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1ccm.QuestionsCta), {
                    product: "Jira",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("in5fb", function(module, exports) {
$parcel$export(module.exports, "DataCenterPromoCard", function () { return $a35fac25401ec131$export$3e66a33f1e68491c; });
/* data-center-promo-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2fk4i = parcelRequire("2fk4i");
const $a35fac25401ec131$export$3e66a33f1e68491c = ({ dataCenterContent: dataCenterContent })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1bsbauwl _1pfh1ejb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Card), {
            orientation: "horizontal",
            columns: 10,
            title: dataCenterContent.title,
            body: dataCenterContent.description,
            callToAction: {
                text: "Learn more",
                href: "/enterprise/data-center"
            },
            // eslint-disable-next-line local/no-non-orangelogic-images-eslint
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Illo_DataCenter.svg"
        })
    });
};

});

parcelRegister("kIC93", function(module, exports) {
$parcel$export(module.exports, "TwcPromo", function () { return $3b570c8d1312e036$export$f72cba571c49850d; });
/* twc-promo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $3b570c8d1312e036$export$f72cba571c49850d = ({ product: product })=>{
    const intl = (0, $8e22h.default)();
    let text = intl.formatMessage({
        id: "TeamworkCollection.promo.jira.body",
        defaultMessage: "Get Jira, Confluence, Loom, and Rovo in one collection to bring together projects, knowledge, video communication, and AI-powered insights."
    });
    if (product === "confluence") text = intl.formatMessage({
        id: "TeamworkCollection.promo.confluence.body",
        defaultMessage: "Get Confluence, Jira, Loom, and Rovo in one collection to bring together knowledge, projects, video communication, and AI-powered insights."
    });
    if (product === "loom") text = intl.formatMessage({
        id: "TeamworkCollection.promo.loom.body",
        defaultMessage: "Get Loom, Jira, Confluence, and Rovo in one collection to bring together video communication, projects, knowledge, and AI-powered insights."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1bsbauwl _1mouxy5q"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
            logo: "teamworkCollection",
            title: intl.formatMessage({
                id: "TeamworkCollection.promo.title",
                defaultMessage: "All your tools, one collection"
            }),
            text: text,
            callToActionProps: {
                link: {
                    text: intl.formatMessage({
                        id: "TeamworkCollection.promo.body",
                        defaultMessage: "Explore Teamwork Collection"
                    }),
                    href: "/collections/teamwork"
                }
            },
            pictureProps: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1q83t675w16167510pu524e7ccp6n551.png",
                    alt: ""
                }
            },
            orientation: "horizontal-reverse",
            columns: 12,
            backgroundColor: `${(0, $kbpa7.wacToken)("color.extended.blue200")}`,
            hat: "high-right"
        })
    });
};

});

parcelRegister("bCS4H", function(module, exports) {
$parcel$export(module.exports, "PricingFaq", function () { return (parcelRequire("bE8d4")).PricingFaq; });
$parcel$export(module.exports, "QuotationsAdornment", function () { return (parcelRequire("2zOxm")).QuotationsAdornment; });
parcelRequire("bE8d4");
parcelRequire("2zOxm");

});

parcelRegister("1YZW1", function(module, exports) {
$parcel$export(module.exports, "PricingPageLayout", function () { return (parcelRequire("grcEk")).PricingPageLayout; });
$parcel$export(module.exports, "PageHeading", function () { return (parcelRequire("6Px6U")).PageHeading; });
parcelRequire("grcEk");
parcelRequire("6Px6U");

});
parcelRegister("grcEk", function(module, exports) {
$parcel$export(module.exports, "PricingPageLayout", function () { return $229e6cc32b6909b5$export$179602f42864b2b8; });
/* pricing-page-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8LaTa = parcelRequire("8LaTa");

var $jvvcS = parcelRequire("jvvcS");
const $229e6cc32b6909b5$export$179602f42864b2b8 = ({ nav: nav, banner: banner, hero: hero, bgColor: bgColor, hasGlobalFooter: hasGlobalFooter = true, showFallback: showFallback = false, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            nav && nav,
            !showFallback && banner,
            !showFallback && hero,
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    background: bgColor
                },
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1q51vbgk _85i5vbgk _xc2ickbl _1u2qzwfg"
                ]),
                children: [
                    showFallback && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jvvcS.PricingPageFallback), {}),
                    !showFallback && children && /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                        id: "content",
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _zulpvbgk _p12ftfvk _1bsbaq80 _vqct1h22 _1wfq1ul9 _15vt1ul9 _v7361wqb _chtu1wqb _8164ckbl _63vr1vh9 _1tbz1ul9 _68811ul9"
                        ]),
                        children: children
                    })
                ]
            }),
            hasGlobalFooter && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhvbgk _476dckbl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
            })
        ]
    });
};
const $229e6cc32b6909b5$var$footerCss = null;
const $229e6cc32b6909b5$var$pricingPageLayoutOuterCss = null;
const $229e6cc32b6909b5$var$pricingPageLayoutInnerCss = null;

});
parcelRegister("jvvcS", function(module, exports) {
$parcel$export(module.exports, "PricingPageFallback", function () { return $a5f2023cdede46a1$export$54fc8f6b9874893e; });
/* pricing-page-fallback.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $a5f2023cdede46a1$export$54fc8f6b9874893e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3idtre _1e0c1txw _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "PageFallback.message",
            defaultMessage: "An unexpected error occurred. Please try again later."
        })
    });
};

});


parcelRegister("6Px6U", function(module, exports) {
$parcel$export(module.exports, "PageHeading", function () { return $9310efba541b4555$export$9716a88f5535df7c; });
/* page-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $imIsw = parcelRequire("imIsw");
const $9310efba541b4555$export$9716a88f5535df7c = (props)=>{
    const { as: Component = "h1", children: children } = props, rest = (0, $aPnCa._)(props, [
        "as",
        "children"
    ]);
    const headingStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpftgi"
        ]),
        children: [
            typeof children === "string" ? /*#__PURE__*/ (0, $7VQPk.jsx)("h1", (0, $dPABA._)((0, $6ogO3._)({}, rest), {
                dangerouslySetInnerHTML: {
                    __html: children
                },
                className: (0, $2jatx.default)([
                    "_k48p1fw0 _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1s18ckbl _1cqs1ady _1qjn1ylp _syazqlpt"
                ])
            })) : /*#__PURE__*/ (0, $7VQPk.jsx)("h1", (0, $dPABA._)((0, $6ogO3._)({}, rest), {
                className: (0, $2jatx.default)([
                    "_k48p1fw0 _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1s18ckbl _1cqs1ady _1qjn1ylp _syazqlpt"
                ]),
                children: children
            })),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ox5132cg4k77h80v02063670d5th386i.svg",
                    alt: ""
                }
            })
        ]
    });
};

});


parcelRegister("5S2vX", function(module, exports) {
$parcel$export(module.exports, "useParentScrollTracking", function () { return $d703c208f3e9c795$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $d703c208f3e9c795$export$248f1dfc9396e7e4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("j6FQw");
var $je135 = parcelRequire("je135");
const $d703c208f3e9c795$var$ScrollTrackingContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $d703c208f3e9c795$export$164ddb76b909974a = ()=>{
    return (0, $1oC0p.useContext)($d703c208f3e9c795$var$ScrollTrackingContext);
};
const $d703c208f3e9c795$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $d703c208f3e9c795$export$164ddb76b909974a();
    const arrayChildren = (0, $1oC0p.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    var _props_pageId;
    const pageId = (_props_pageId = props.pageId) !== null && _props_pageId !== void 0 ? _props_pageId : parentContext.pageId;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d703c208f3e9c795$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $1oC0p.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});
parcelRegister("j6FQw", function(module, exports) {
$parcel$export(module.exports, "ScrollTracking", function () { return (parcelRequire("je135")).ScrollTracking; });
$parcel$export(module.exports, "useScrollTracking", function () { return (parcelRequire("je135")).useScrollTracking; });
$parcel$export(module.exports, "withScrollTracking", function () { return (parcelRequire("je135")).withScrollTracking; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return (parcelRequire("5S2vX")).ParentScrollTracking; });
parcelRequire("je135");
parcelRequire("5S2vX");

});
parcelRegister("je135", function(module, exports) {
$parcel$export(module.exports, "useScrollTracking", function () { return $0fbf1a9bc3d0315b$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $0fbf1a9bc3d0315b$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $0fbf1a9bc3d0315b$export$391633ede08dabb1; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $5S2vX = parcelRequire("5S2vX");

var $iSeHD = parcelRequire("iSeHD");
const $0fbf1a9bc3d0315b$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $1oC0p.useRef)(false);
    const scrollPercentage = (0, $1oC0p.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $5S2vX.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $jKShK.useInView)((0, $dPABA._)((0, $6ogO3._)({
        threshold: 0.5,
        triggerOnce: true
    }, observerOptions), {
        skip: (observerOptions === null || observerOptions === void 0 ? void 0 : observerOptions.skip) || !scrollTrackingEnabled
    }));
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $6ogO3._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: "ui",
                action: "dwellTimeTracked",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $6ogO3._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            if (analyticsClient) {
                createAnalyticsEvent((0, $6ogO3._)({}, scrollTrackAnalyticsPayload)).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    "mousemove",
                    "keydown",
                    "scroll",
                    "touchstart"
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent((0, $6ogO3._)({}, dwellTimeTrackAnalyticsPayload)).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $0fbf1a9bc3d0315b$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $0fbf1a9bc3d0315b$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $0fbf1a9bc3d0315b$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)($0fbf1a9bc3d0315b$export$1725757b7947b890, (0, $dPABA._)((0, $6ogO3._)({
            section: section
        }, options), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, (0, $6ogO3._)({}, props))
        }));
    };
}

});



parcelRegister("b7CnU", function(module, exports) {
$parcel$export(module.exports, "JiraPriceFinder", function () { return $be32cafd3b047742$export$1bf486cdabb14f4d; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");
const $be32cafd3b047742$export$1bf486cdabb14f4d = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1, _content_enterprise, _content_enterprise1, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)("Free"),
        standard: (0, $dl2JF.usePricingPlanComparison)("Standard"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Premium"),
        enterprise: (0, $dl2JF.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "enterprise");
    const signupLimit = 100000;
    var _content_free_planTitleExternal, _content_free_planOneLiner, _content_standard_planTitleExternal, _content_standard_planOneLiner, _content_premium_planTitleExternal, _content_premium_planOneLiner, _content_enterprise_planTitleExternal, _content_enterprise_planOneLiner;
    // planNames should not be translated
    const jswProductPlans = [
        {
            planName: (_content_free_planTitleExternal = (_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) !== null && _content_free_planTitleExternal !== void 0 ? _content_free_planTitleExternal : "Free",
            offeringSku: "jira-software-free",
            description: (_content_free_planOneLiner = (_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) !== null && _content_free_planOneLiner !== void 0 ? _content_free_planOneLiner : "",
            recommendationLimit: 0,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=free&editionIntent=free&signupSource=pricing",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: (_content_standard_planTitleExternal = (_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) !== null && _content_standard_planTitleExternal !== void 0 ? _content_standard_planTitleExternal : "Standard",
            offeringSku: "jira-software-standard",
            description: (_content_standard_planOneLiner = (_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) !== null && _content_standard_planOneLiner !== void 0 ? _content_standard_planOneLiner : "",
            recommendationLimit: 10,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=standard&signupSource=pricing",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: (_content_premium_planTitleExternal = (_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) !== null && _content_premium_planTitleExternal !== void 0 ? _content_premium_planTitleExternal : "Premium",
            offeringSku: "jira-software-premium",
            description: (_content_premium_planOneLiner = (_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) !== null && _content_premium_planOneLiner !== void 0 ? _content_premium_planOneLiner : "",
            recommendationLimit: 250,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=premium&signupSource=pricing",
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: (_content_enterprise_planTitleExternal = (_content_enterprise = content.enterprise) === null || _content_enterprise === void 0 ? void 0 : _content_enterprise.planTitleExternal) !== null && _content_enterprise_planTitleExternal !== void 0 ? _content_enterprise_planTitleExternal : "Enterprise",
            offeringSku: "jira-software-enterprise-sku",
            recommendationLimit: 5000,
            description: (_content_enterprise_planOneLiner = (_content_enterprise1 = content.enterprise) === null || _content_enterprise1 === void 0 ? void 0 : _content_enterprise1.planOneLiner) !== null && _content_enterprise_planOneLiner !== void 0 ? _content_enterprise_planOneLiner : "",
            signupLimit: signupLimit,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: "JiraSoftwarePricingPageV2.priceFinder.header",
            defaultMessage: "<blue>Simple, transparent pricing</blue> for every team."
        },
        unitCountInputText: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTextRedesign: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "JiraSoftwarePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputTooltip: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Jira Software user is any user who can log in to Jira Software, and who exists in User Management"
        },
        cardOverSignupLimit: {
            id: "JiraSoftwarePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "JiraSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "JiraSoftwarePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "JiraSoftwarePricingPageV2.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "JiraSoftwarePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            productPlans: jswProductPlans,
            dataProductKey: "jiraSoftware",
            defaultUnitCount: 300,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.jiraSoftware,
                countryCode: props.countryCode
            })
        })
    });
};
$be32cafd3b047742$export$1bf486cdabb14f4d.displayName = "JiraPriceFinder";

});
parcelRegister("1qGP5", function(module, exports) {
$parcel$export(module.exports, "createPlanFeatureMessages", function () { return $9f8554c0837366fe$export$8fd76139fda318d8; });

var $7VQPk = parcelRequire("7VQPk");
const $9f8554c0837366fe$export$68568ac1e2cced1f = (highlightedFeatures)=>{
    return highlightedFeatures.map((highlight)=>({
            featureMessage: highlight.highlightedFeatureDetails ? {
                text: highlight.highlightedFeatureTitleExternal,
                content: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: highlight.highlightedFeatureDetails
                        }
                    })
            } : highlight.highlightedFeatureTitleExternal,
            lozengeText: highlight.callOut
        }));
};
const $9f8554c0837366fe$export$8fd76139fda318d8 = (content, planKey)=>{
    const plan = content === null || content === void 0 ? void 0 : content[planKey];
    return (plan === null || plan === void 0 ? void 0 : plan.highlightedFeaturesContainer) ? $9f8554c0837366fe$export$68568ac1e2cced1f(plan.highlightedFeaturesContainer) : [];
};

});





parcelRegister("jmley", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gfjAv")).default; });

var $gfjAv = parcelRequire("gfjAv");

});

parcelRegister("jEVVm", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9BZqy"));

});
parcelRegister("9BZqy", function(module, exports) {
$parcel$export(module.exports, "unstable_now", function () { return $6ff737efae05bc89$export$c4744153514ff05d; }, function (v) { return $6ff737efae05bc89$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7; }, function (v) { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6ff737efae05bc89$export$e26fe2ed2fa76875; }, function (v) { return $6ff737efae05bc89$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6ff737efae05bc89$export$502329bbf4b505b1; }, function (v) { return $6ff737efae05bc89$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6ff737efae05bc89$export$6e3807111c4874c4; }, function (v) { return $6ff737efae05bc89$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6ff737efae05bc89$export$c27134553091fb3a; }, function (v) { return $6ff737efae05bc89$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6ff737efae05bc89$export$33ee1acdc04fd2a2; }, function (v) { return $6ff737efae05bc89$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6ff737efae05bc89$export$b00a404bbd5edef2; }, function (v) { return $6ff737efae05bc89$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6ff737efae05bc89$export$d66a1c1c77bd778b; }, function (v) { return $6ff737efae05bc89$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6ff737efae05bc89$export$d3dfb8e4810cb555; }, function (v) { return $6ff737efae05bc89$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6ff737efae05bc89$export$72fdf0e06517287b; }, function (v) { return $6ff737efae05bc89$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6ff737efae05bc89$export$816d2913ae6b83b1; }, function (v) { return $6ff737efae05bc89$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6ff737efae05bc89$export$61bcfe829111a1d0; }, function (v) { return $6ff737efae05bc89$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6ff737efae05bc89$export$7ee8c9beb337bc3f; }, function (v) { return $6ff737efae05bc89$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6ff737efae05bc89$export$b5836b71941fa3ed; }, function (v) { return $6ff737efae05bc89$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6ff737efae05bc89$export$cf845f2c119da08a; }, function (v) { return $6ff737efae05bc89$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6ff737efae05bc89$export$c4744153514ff05d;
var $6ff737efae05bc89$export$3e506c1ccc9cc1a7;
var $6ff737efae05bc89$export$e26fe2ed2fa76875;
var $6ff737efae05bc89$export$502329bbf4b505b1;
var $6ff737efae05bc89$export$6e3807111c4874c4;
var $6ff737efae05bc89$export$c27134553091fb3a;
var $6ff737efae05bc89$export$33ee1acdc04fd2a2;
var $6ff737efae05bc89$export$b00a404bbd5edef2;
var $6ff737efae05bc89$export$d66a1c1c77bd778b;
var $6ff737efae05bc89$export$d3dfb8e4810cb555;
var $6ff737efae05bc89$export$72fdf0e06517287b;
var $6ff737efae05bc89$export$816d2913ae6b83b1;
var $6ff737efae05bc89$export$61bcfe829111a1d0;
var $6ff737efae05bc89$export$7ee8c9beb337bc3f;
var $6ff737efae05bc89$export$b5836b71941fa3ed;
var $6ff737efae05bc89$export$cf845f2c119da08a;
"use strict";
function $6ff737efae05bc89$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $6ff737efae05bc89$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $6ff737efae05bc89$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $6ff737efae05bc89$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $6ff737efae05bc89$var$compare(left, last)) rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $6ff737efae05bc89$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$6ff737efae05bc89$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6ff737efae05bc89$var$localPerformance = performance;
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localPerformance.now();
    };
} else {
    var $6ff737efae05bc89$var$localDate = Date, $6ff737efae05bc89$var$initialTime = $6ff737efae05bc89$var$localDate.now();
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localDate.now() - $6ff737efae05bc89$var$initialTime;
    };
}
var $6ff737efae05bc89$var$taskQueue = [], $6ff737efae05bc89$var$timerQueue = [], $6ff737efae05bc89$var$taskIdCounter = 1, $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = 3, $6ff737efae05bc89$var$isPerformingWork = !1, $6ff737efae05bc89$var$isHostCallbackScheduled = !1, $6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$needsPaint = !1, $6ff737efae05bc89$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $6ff737efae05bc89$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $6ff737efae05bc89$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $6ff737efae05bc89$var$advanceTimers(currentTime) {
    for(var timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue); null !== timer;){
        if (null === timer.callback) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue);
        else if (timer.startTime <= currentTime) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue), timer.sortIndex = timer.expirationTime, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, timer);
        else break;
        timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
    }
}
function $6ff737efae05bc89$var$handleTimeout(currentTime) {
    $6ff737efae05bc89$var$isHostTimeoutScheduled = !1;
    $6ff737efae05bc89$var$advanceTimers(currentTime);
    if (!$6ff737efae05bc89$var$isHostCallbackScheduled) {
        if (null !== $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue)) $6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $6ff737efae05bc89$var$isMessageLoopRunning = !1, $6ff737efae05bc89$var$taskTimeoutID = -1, $6ff737efae05bc89$var$frameInterval = 5, $6ff737efae05bc89$var$startTime = -1;
function $6ff737efae05bc89$var$shouldYieldToHost() {
    return $6ff737efae05bc89$var$needsPaint ? !0 : $6ff737efae05bc89$export$c4744153514ff05d() - $6ff737efae05bc89$var$startTime < $6ff737efae05bc89$var$frameInterval ? !1 : !0;
}
function $6ff737efae05bc89$var$performWorkUntilDeadline() {
    $6ff737efae05bc89$var$needsPaint = !1;
    if ($6ff737efae05bc89$var$isMessageLoopRunning) {
        var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
        $6ff737efae05bc89$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $6ff737efae05bc89$var$isHostCallbackScheduled = !1;
                $6ff737efae05bc89$var$isHostTimeoutScheduled && ($6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1);
                $6ff737efae05bc89$var$isPerformingWork = !0;
                var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
                try {
                    b: {
                        $6ff737efae05bc89$var$advanceTimers(currentTime);
                        for($6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue); null !== $6ff737efae05bc89$var$currentTask && !($6ff737efae05bc89$var$currentTask.expirationTime > currentTime && $6ff737efae05bc89$var$shouldYieldToHost());){
                            var callback = $6ff737efae05bc89$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $6ff737efae05bc89$var$currentTask.callback = null;
                                $6ff737efae05bc89$var$currentPriorityLevel = $6ff737efae05bc89$var$currentTask.priorityLevel;
                                var continuationCallback = callback($6ff737efae05bc89$var$currentTask.expirationTime <= currentTime);
                                currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $6ff737efae05bc89$var$currentTask.callback = continuationCallback;
                                    $6ff737efae05bc89$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $6ff737efae05bc89$var$currentTask === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                                $6ff737efae05bc89$var$advanceTimers(currentTime);
                            } else $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                            $6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue);
                        }
                        if (null !== $6ff737efae05bc89$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
                            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel, $6ff737efae05bc89$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline() : $6ff737efae05bc89$var$isMessageLoopRunning = !1;
        }
    }
}
var $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $6ff737efae05bc89$var$localSetImmediate) $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetImmediate($6ff737efae05bc89$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6ff737efae05bc89$var$channel = new MessageChannel(), $6ff737efae05bc89$var$port = $6ff737efae05bc89$var$channel.port2;
    $6ff737efae05bc89$var$channel.port1.onmessage = $6ff737efae05bc89$var$performWorkUntilDeadline;
    $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
        $6ff737efae05bc89$var$port.postMessage(null);
    };
} else $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetTimeout($6ff737efae05bc89$var$performWorkUntilDeadline, 0);
};
function $6ff737efae05bc89$var$requestHostTimeout(callback, ms) {
    $6ff737efae05bc89$var$taskTimeoutID = $6ff737efae05bc89$var$localSetTimeout(function() {
        callback($6ff737efae05bc89$export$c4744153514ff05d());
    }, ms);
}
$6ff737efae05bc89$export$3e506c1ccc9cc1a7 = 5;
$6ff737efae05bc89$export$e26fe2ed2fa76875 = 1;
$6ff737efae05bc89$export$502329bbf4b505b1 = 4;
$6ff737efae05bc89$export$6e3807111c4874c4 = 3;
$6ff737efae05bc89$export$c27134553091fb3a = null;
$6ff737efae05bc89$export$33ee1acdc04fd2a2 = 2;
$6ff737efae05bc89$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$6ff737efae05bc89$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6ff737efae05bc89$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$6ff737efae05bc89$export$d3dfb8e4810cb555 = function() {
    return $6ff737efae05bc89$var$currentPriorityLevel;
};
$6ff737efae05bc89$export$72fdf0e06517287b = function(eventHandler) {
    switch($6ff737efae05bc89$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$816d2913ae6b83b1 = function() {
    $6ff737efae05bc89$var$needsPaint = !0;
};
$6ff737efae05bc89$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $6ff737efae05bc89$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$timerQueue, priorityLevel), null === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && priorityLevel === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue) && ($6ff737efae05bc89$var$isHostTimeoutScheduled ? ($6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1) : $6ff737efae05bc89$var$isHostTimeoutScheduled = !0, $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, priorityLevel), $6ff737efae05bc89$var$isHostCallbackScheduled || $6ff737efae05bc89$var$isPerformingWork || ($6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$6ff737efae05bc89$export$b5836b71941fa3ed = $6ff737efae05bc89$var$shouldYieldToHost;
$6ff737efae05bc89$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
        $6ff737efae05bc89$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("ixLXc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bOBs2"));

});
parcelRegister("bOBs2", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", function () { return $89a16a416bb12add$export$306c0aa65ff9ec16; }, function (v) { return $89a16a416bb12add$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89a16a416bb12add$export$306c0aa65ff9ec16;
'use strict';

var $1oC0p = parcelRequire("1oC0p");
function $89a16a416bb12add$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $89a16a416bb12add$var$k = "function" === typeof Object.is ? Object.is : $89a16a416bb12add$var$h, $89a16a416bb12add$var$l = $1oC0p.useState, $89a16a416bb12add$var$m = $1oC0p.useEffect, $89a16a416bb12add$var$n = $1oC0p.useLayoutEffect, $89a16a416bb12add$var$p = $1oC0p.useDebugValue;
function $89a16a416bb12add$var$q(a, b) {
    var d = b(), f = $89a16a416bb12add$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $89a16a416bb12add$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $89a16a416bb12add$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $89a16a416bb12add$var$m(function() {
        $89a16a416bb12add$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $89a16a416bb12add$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $89a16a416bb12add$var$p(d);
    return d;
}
function $89a16a416bb12add$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$89a16a416bb12add$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $89a16a416bb12add$var$t(a, b) {
    return b();
}
var $89a16a416bb12add$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $89a16a416bb12add$var$t : $89a16a416bb12add$var$q;
$89a16a416bb12add$export$306c0aa65ff9ec16 = void 0 !== $1oC0p.useSyncExternalStore ? $1oC0p.useSyncExternalStore : $89a16a416bb12add$var$u;

});


parcelRegister("lOlsU", function(module, exports) {
$parcel$export(module.exports, "useFirePricingPlanCtaEvent", function () { return $94595cb38e128ae6$export$7f90eaa475fc1c9f; });

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");
function $94595cb38e128ae6$export$7f90eaa475fc1c9f(props) {
    const { edition: edition, productKey: productKey, containerId: containerId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const createPayload = ()=>({
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            containerId: containerId,
            actionSubjectId: "pricingPlanCta",
            attributes: {
                migrationExperimentCta: true,
                pricingEventId: (0, $fuLgT.default)(),
                productKey: productKey,
                edition: edition
            }
        });
    return ()=>createAnalyticsEvent(createPayload()).fire();
}

});

parcelRegister("1RK9J", function(module, exports) {
$parcel$export(module.exports, "getFreePriceCalc", function () { return $9f9b50f36097439e$export$cb6f0dbb8c9b28d2; });
$parcel$export(module.exports, "usePriceFinderRequests", function () { return $9f9b50f36097439e$export$e1ef037d62746bfa; });
$parcel$export(module.exports, "usePricing", function () { return $9f9b50f36097439e$export$2bd1dff4b72a4894; });

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");
const $9f9b50f36097439e$export$cb6f0dbb8c9b28d2 = (currencyISOCode)=>{
    const zeroPrice = (0, $ieLA0.getFormattedPrice)(currencyISOCode, 0);
    return {
        totalPrice: 0,
        avgPerUnitPrice: 0,
        avgPerUnitPriceWithDiscount: 0,
        formattedTotalPrice: zeroPrice,
        formattedAvgPerUnitPrice: zeroPrice,
        formattedAvgPerUnitPriceWithDiscount: zeroPrice,
        formattedTotalPriceWithDiscount: zeroPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: 0,
                unitsAvailableInTier: 0,
                unitLimitLower: 0,
                unitLimitUpper: 0,
                totalPriceForTier: 0,
                avgPerUnitPriceForTier: 0
            }
        ],
        formattedBreakdown: [
            {
                formattedUnitsInTier: "0",
                formattedUnitsAvailableInTier: "0",
                formattedUnitLimitLower: "0",
                formattedUnitLimitUpper: "0",
                formattedTotalPriceForTier: zeroPrice,
                formattedAvgPerUnitPriceForTier: zeroPrice
            }
        ]
    };
};
const $9f9b50f36097439e$export$e1ef037d62746bfa = (productKey, productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    return (0, $1oC0p.useMemo)(()=>{
        const getNumUnits = (planName, signupUnitLimit)=>{
            let adjNumUnits = 0;
            // following scenarios do not have pricing and should send a zero unit count,
            // the zero pricing will not be displayed and is needed only to retain the
            // correct array order of the pricing requests/responses
            // Free plan has no pricing
            const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
            // Enterprise plans do not have monthly pricing
            const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
            // Enterprise plans have a minimum unit count
            const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
            const isOverSignupUnitLimit = unitCount > signupUnitLimit;
            if (![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)) adjNumUnits = unitCount;
            // keep unit count to general maximum limit
            return Math.min(adjNumUnits, signupUnitLimit);
        };
        const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
                ccpOfferingSKU: offeringSku,
                hamsProductKey: productKey + (planName === (0, $hrGO1.SpecialPlanNames).STANDARD ? "" : `.${planName.toLowerCase()}`),
                numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
                period: billingCycle
            }));
        return planPriceReqs;
    }, [
        productPlans,
        productKey,
        billingCycle,
        unitCount,
        unitMinEnterprise
    ]);
};
const $9f9b50f36097439e$export$2bd1dff4b72a4894 = (ccpPricingData, hamsPricingData, getPriceRequests, currencyISOCode, localeISOCode)=>{
    const priceCalculations = [];
    for (const { ccpOfferingSKU: ccpOfferingSKU, hamsProductKey: hamsProductKey, numUnits: numUnits, period: period } of getPriceRequests)if (numUnits === 0) priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
    else {
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, hamsPricingData, period, currencyISOCode, ccpOfferingSKU, hamsProductKey);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
        } else priceCalculations.push((0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
    return priceCalculations;
};

});
parcelRegister("ieLA0", function(module, exports) {
$parcel$export(module.exports, "getFormattedPrice", function () { return $db8d9502e3c15040$export$1b80ff309ec5fcb1; });
$parcel$export(module.exports, "getTwoDigitFormattedPrice", function () { return $db8d9502e3c15040$export$716b461c5fe22c57; });
$parcel$export(module.exports, "getFormattedUnitAmount", function () { return $db8d9502e3c15040$export$4f6f7f43804883a5; });
const $db8d9502e3c15040$export$93b318a4d10f1db1 = (value)=>{
    if (value !== null && value !== undefined && !Number.isNaN(value)) return Number.isInteger(+value) ? 0 : 2;
    else return 0;
};
const $db8d9502e3c15040$var$fmtCurrencyValue = (currencyISOCode, value, useTwoDigits)=>{
    const isJPY = currencyISOCode === "JPY";
    const adjVal = isJPY ? Math.ceil(value || 0) : value;
    return new Intl.NumberFormat(isJPY ? "ja-JP" : "en-US", {
        style: "currency",
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal),
        maximumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal)
    }).format(adjVal || 0);
};
const $db8d9502e3c15040$export$1b80ff309ec5fcb1 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, false);
const $db8d9502e3c15040$export$716b461c5fe22c57 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, true);
const $db8d9502e3c15040$export$4f6f7f43804883a5 = (localeISOCode, value)=>new Intl.NumberFormat(localeISOCode).format(value || 0);

});

parcelRegister("69Lp1", function(module, exports) {
$parcel$export(module.exports, "extractPricingTiersFromEntry", function () { return $eeff08f2d55148ea$export$99b3bd15b49bca3d; });

var $6AKYt = parcelRequire("6AKYt");
const $eeff08f2d55148ea$export$99b3bd15b49bca3d = (ccpOfferingsBySKU, hamsPricingPlansByKey, period, currencyISOCode, ccpOfferingSKU, hamsProductKey, getCcpTiers)=>{
    let pricingPlans;
    let pricingTiers;
    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];
        pricingPlans = offering === null || offering === void 0 ? void 0 : offering.defaultPricingPlans;
        if (!pricingPlans) {
            console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
            return undefined;
        }
        const convertedTiers = (0, $6AKYt.convertCCPPricingPlansToHAMS)(pricingPlans, currencyISOCode, getCcpTiers);
        if (period === "MONTHLY" && convertedTiers.monthly) pricingTiers = convertedTiers.monthly.slice();
        else if (period === "ANNUAL" && convertedTiers.annual) pricingTiers = convertedTiers.annual.slice();
        else {
            console.log(`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`);
            return undefined;
        }
    } else {
        if (hamsProductKey === undefined) {
            console.log(`HAMS product key was undefined for price request!`);
            return undefined;
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
        if (period === "MONTHLY" && pricingPlans.monthly) pricingTiers = pricingPlans.monthly.slice();
        else if (period === "ANNUAL" && pricingPlans.annual) pricingTiers = pricingPlans.annual.slice();
        else {
            console.log(`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
    }
    return pricingTiers;
};

});
parcelRegister("6AKYt", function(module, exports) {
$parcel$export(module.exports, "convertCCPPricingPlansToHAMS", function () { return $ba494f9c4080e515$export$1fb00d50ed2ce89c; });

var $hrGO1 = parcelRequire("hrGO1");
// CCP Amounts are stored in cents - Note: JPY needs no conversion
const $ba494f9c4080e515$var$formatCentsToDollars = (value, currency)=>{
    if (currency === "USD" && value) return value / 100;
    return value;
};
const $ba494f9c4080e515$var$convertCCPTiersToHAMS = (ccpTiers, chargeElement, currency)=>ccpTiers.map((ccpTier)=>{
        let pricingStrategy = (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = (0, $hrGO1.PricingStrategy).FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy: pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency: currency,
                    unitPrice: $ba494f9c4080e515$var$formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });
const $ba494f9c4080e515$export$1fb00d50ed2ce89c = (pricingPlans, currencyISOCode, getCcpTiers)=>{
    const [monthlyCCP, annualCCP] = [
        "MONTH",
        "YEAR"
    ].map((primaryCycle)=>// Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find((pricingPlan)=>pricingPlan.primaryCycle_interval === primaryCycle && pricingPlan.type === "COMMERCIAL" && pricingPlan.activatedWithReason === "DEFAULT_PRICING" && // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
            // If needed, can filter by USD only which we will pass in directly in those components
            pricingPlan.currency === currencyISOCode));
    const [monthly, annual] = [
        monthlyCCP,
        annualCCP
    ].map((ccpContent)=>{
        if (!ccpContent) return undefined;
        const ccpTiers = getCcpTiers ? getCcpTiers(ccpContent) : ccpContent.items[0];
        const { tiers: tiers, chargeElement: chargeElement } = ccpTiers;
        return $ba494f9c4080e515$var$convertCCPTiersToHAMS(tiers, chargeElement, ccpContent.currency);
    });
    return {
        monthly: monthly,
        annual: annual
    };
};

});


parcelRegister("8dsKS", function(module, exports) {
$parcel$export(module.exports, "calculatePrice", function () { return $9c8fafac440a889f$export$8f857d3e1dbdf9cf; });

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $cuq2S = parcelRequire("cuq2S");

var $fmcUV = parcelRequire("fmcUV");
const $9c8fafac440a889f$var$getTierIdxForNumUnits = (numUnits, tiers)=>tiers.findIndex(({ unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper })=>numUnits >= (unitLimitLower || 0) && numUnits <= (unitLimitUpper || Math.pow(10, 1000)));
function $9c8fafac440a889f$export$8f857d3e1dbdf9cf(numUnits, tiers, currencyISOCode, period, localeISOCode = "en-US") {
    if (!Number.isInteger(numUnits) || numUnits < 1) throw new Error(`Number of units must be a positive non-zero integer, got ${numUnits}.`);
    if (!tiers || tiers.length === 0) throw new Error(`Price tiers must not be null, undefined or an empty array, got ${tiers}.`);
    tiers.sort((a, b)=>{
        var _a_unitLimitLower, _b_unitLimitLower;
        return ((_a_unitLimitLower = a.unitLimitLower) !== null && _a_unitLimitLower !== void 0 ? _a_unitLimitLower : 0) - ((_b_unitLimitLower = b.unitLimitLower) !== null && _b_unitLimitLower !== void 0 ? _b_unitLimitLower : 0);
    });
    let matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(numUnits, tiers);
    const matchingTier = tiers[matchingTierIdx];
    const finalTier = tiers[tiers.length - 1];
    let adjustedNumberOfUnits = numUnits;
    let calcFunc;
    if (matchingTier !== undefined) {
        const tierPricingStrategy = matchingTier.pricingStrategy;
        calcFunc = period === "MONTHLY" || tierPricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT ? (0, $fmcUV.default) : (0, $cuq2S.default);
    } else if (finalTier && finalTier.pricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT) calcFunc = (0, $fmcUV.default);
    else {
        /*
     * When a user input is greater than the max tier limit
     * we will reset the number of users to max tier limit
     * of that product and perform price calculations.
     * */ adjustedNumberOfUnits = (finalTier === null || finalTier === void 0 ? void 0 : finalTier.unitLimitUpper) || 0;
        matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(adjustedNumberOfUnits, tiers);
        calcFunc = (0, $cuq2S.default);
    }
    const fmtUnit = (amount)=>(0, $ieLA0.getFormattedUnitAmount)(localeISOCode, amount);
    const fmtPrice = (price)=>(0, $ieLA0.getFormattedPrice)(currencyISOCode, price);
    const { totalPrice: totalPrice, avgPerUnitPrice: avgPerUnitPrice, hasFlatRateFirstTier: hasFlatRateFirstTier, breakdown: breakdown } = calcFunc(adjustedNumberOfUnits, matchingTierIdx, tiers, currencyISOCode);
    const avgPerUnitPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, avgPerUnitPrice);
    const totalPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, totalPrice);
    return {
        totalPrice: totalPrice,
        avgPerUnitPriceWithDiscount: avgPerUnitPriceWithDiscount,
        formattedTotalPrice: fmtPrice(totalPrice),
        formattedAvgPerUnitPriceWithDiscount: fmtPrice(avgPerUnitPriceWithDiscount),
        formattedTotalPriceWithDiscount: fmtPrice(totalPriceWithDiscount),
        avgPerUnitPrice: avgPerUnitPrice,
        formattedAvgPerUnitPrice: fmtPrice(avgPerUnitPrice),
        breakdown: breakdown,
        hasFlatRateFirstTier: hasFlatRateFirstTier,
        formattedBreakdown: breakdown.map(({ unitsInTier: unitsInTier, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsAvailableInTier: unitsAvailableInTier, totalPriceForTier: totalPriceForTier, avgPerUnitPriceForTier: avgPerUnitPriceForTier })=>({
                formattedUnitsInTier: fmtUnit(unitsInTier),
                formattedUnitsAvailableInTier: fmtUnit(unitsAvailableInTier),
                formattedUnitLimitLower: fmtUnit(unitLimitLower),
                formattedUnitLimitUpper: fmtUnit(unitLimitUpper),
                formattedTotalPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, totalPriceForTier),
                formattedAvgPerUnitPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, avgPerUnitPriceForTier)
            }))
    };
}

});
parcelRegister("cuq2S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20e5665ddc9d914c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "calculateDiscountedPrice", function () { return $20e5665ddc9d914c$export$3a875854e1248ca4; });

var $8q2jX = parcelRequire("8q2jX");
function $20e5665ddc9d914c$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    const matchingTier = tiers[matchingTierIdx];
    if (!matchingTier) throw new Error(`Matching price tier not found for ${numUnits}.`);
    const { prices: prices, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = matchingTier;
    const totalPrice = (0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices.slice());
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: numUnits,
                unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,
                unitLimitLower: unitLimitLower || 1,
                unitLimitUpper: unitLimitUpper || 0,
                totalPriceForTier: totalPrice,
                avgPerUnitPriceForTier: totalPrice / numUnits
            }
        ]
    };
}
const $20e5665ddc9d914c$export$3a875854e1248ca4 = (discountRate, price)=>price * (1 - discountRate);

});
parcelRegister("8q2jX", function(module, exports) {
$parcel$export(module.exports, "getLocalUnitPrice", function () { return $032de19fb775a510$export$e4a3f0ac75d6f09; });
const $032de19fb775a510$export$e4a3f0ac75d6f09 = (currencyISOCode, prices)=>{
    var _prices_find;
    return ((_prices_find = prices.find(({ currency: currency })=>currency === currencyISOCode)) === null || _prices_find === void 0 ? void 0 : _prices_find.unitPrice) || 0;
};

});


parcelRegister("fmcUV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e064390e0d1f8ae6$export$2e2bcd8739ae039; });

var $hrGO1 = parcelRequire("hrGO1");

var $8q2jX = parcelRequire("8q2jX");
function $e064390e0d1f8ae6$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    var _tiers_;
    let totalPrice = 0;
    let price = 0;
    const breakdown = [];
    const getUnitPrice = (prices)=>(0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices);
    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) matchingTierIdx = tiers.length - 1;
    let idx = 0;
    for (const tier of tiers){
        const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);
        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier = idx === matchingTierIdx ? numUnits - adjUnitLimitLower : adjUnitLimitUpper - adjUnitLimitLower;
        if (tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST) price = getUnitPrice(tier.prices.slice());
        else {
            const finalTier = tiers[Math.min(idx, tiers.length - 1)];
            price = getUnitPrice(finalTier.prices.slice());
        }
        const totalPriceForTier = tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST ? price : unitsInTier * price;
        totalPrice += totalPriceForTier;
        breakdown.push({
            unitsInTier: unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,
            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,
            totalPriceForTier: totalPriceForTier,
            avgPerUnitPriceForTier: price
        });
        if (++idx > matchingTierIdx) break;
    }
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: ((_tiers_ = tiers[0]) === null || _tiers_ === void 0 ? void 0 : _tiers_.pricingStrategy) === (0, $hrGO1.PricingStrategy).FIXED_COST,
        breakdown: breakdown
    };
}

});



parcelRegister("fl7Kz", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return (parcelRequire("92jF6")).Card; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("92jF6")).Card; });

var $92jF6 = parcelRequire("92jF6");

});
parcelRegister("92jF6", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $b6adcd00aae9005f$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2tb46 = parcelRequire("2tb46");
const $b6adcd00aae9005f$var$containerStyles = null;
const $b6adcd00aae9005f$var$contentBlockStyles = null;
const $b6adcd00aae9005f$var$barStyles = null;
const $b6adcd00aae9005f$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "#ffffff";
    const cardBackTextColor = textColor !== null && textColor !== void 0 ? textColor : "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor !== null && iconColor !== void 0 ? iconColor : "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $6ZVlx.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $6ZVlx.default)(cardBackTextColor),
            "--_8vvi5m": (0, $6ZVlx.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $2jatx.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});


parcelRegister("8EEDU", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("hBYvx")).Video; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("hBYvx")).Video; });

var $hBYvx = parcelRequire("hBYvx");

});
parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $6ogO3._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        var _videoRef_current;
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});


parcelRegister("aSr2F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7eb3ec80aea1436f$var$_react = $7eb3ec80aea1436f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7eb3ec80aea1436f$var$_baseNew = $7eb3ec80aea1436f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $7eb3ec80aea1436f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7eb3ec80aea1436f$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $7eb3ec80aea1436f$var$_react.default.createElement($7eb3ec80aea1436f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$7eb3ec80aea1436f$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $7eb3ec80aea1436f$var$_default = module.exports.default = $7eb3ec80aea1436f$var$CheckMarkIcon;

});

parcelRegister("fz5gy", function(module, exports) {
$parcel$export(module.exports, "GuardLogo", function () { return $b54e359ca5207dcd$export$a4a891d202775deb; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $b54e359ca5207dcd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $b54e359ca5207dcd$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $b54e359ca5207dcd$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


var $6mvtm = parcelRequire("6mvtm");

var $b7P4C = parcelRequire("b7P4C");

var $3t7DW = parcelRequire("3t7DW");

var $koI83 = parcelRequire("koI83");

var $Q2S5p = parcelRequire("Q2S5p");
const $47e765c72590072d$var$pricingTitleInternal = (0, $koI83.getPricingTitleInternal)();
(0, $3t7DW.init)((0, $Q2S5p.JiraSoftwarePricingPage), (0, $b7P4C.PricingPageRelayQuery), (0, $b7P4C.getPricingPageRelayQueryVars)("jira-software", window.location, $47e765c72590072d$var$pricingTitleInternal), (0, $6mvtm.RELAY_API_CONTENTFUL));


//# sourceMappingURL=jira-software-pricing-page.a6a32c36.js.map
